module.exports = __webpack_public_path__ + "static/media/desert-island_1f3dd.c0b68700.png";